import styled, { css } from 'styled-components';
import mediaQuery from '../../helpers/mediaQuery';
import spacing from '../../helpers/spacing';
import Button from '../Button';

export const IconWrapper = styled.span`
  display: flex;

  margin-left: ${spacing(2)};

  ${mediaQuery.tabletPortrait`
    margin-left: ${spacing(3)};
  `}
`;

export const ButtonStyle = styled(Button)<{ arrowDirection?: 'right' | 'down' }>`
  ${({ arrowDirection, disabled }) => css`
    ${arrowDirection === 'down' &&
    css`
      --rotation: 90deg;
    `}

    ${IconWrapper} {
      transition: transform 0.3s ease-out;
      transform: rotate(var(--rotation));
    }

    &:hover,
    &:focus-visible {
      ${!disabled &&
      css`
        ${IconWrapper} {
          transform: rotate(var(--rotation)) translateX(${spacing(0.5)});
        }
      `}
    }
  `}
`;

export const CtaText = styled.span`
  // This is added for styling in the Tesco component theme
`;

export const CtaTextWrapper = styled.div`
  width: 90%;
  height: auto;
  word-wrap: break-word;
`;
